import './permission-status.scss';
import { ISignerPermisson } from 'constants/signers';
import cn from 'classnames';

interface IPermissionStatus {
  permission: ISignerPermisson;
}

const getPermisionStatus = (permission: ISignerPermisson) => {
  if (permission.isApproved) {
    if (permission.isActive) {
      return ['p_color_green', 'Действительно'];
    }
    return ['p_color_dark-red', 'Не действителено'];
  }
  return ['p_color_dark-yellow', 'На подписании'];
};

export default function PermissionStatus({ permission }: IPermissionStatus) {
  const [modifier, text] = getPermisionStatus(permission);
  return <p className={cn('p', 'p_font-size_14', modifier)}>{text}</p>;
}
